export default __webpack_public_path__ + "static/media/31-min.cc6966d7.png";